import React from 'react';

import { CheckoutLayoutBlock, TipsGroup } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { useCheckoutContext } from '../../../../CheckoutProvider';
import { useCheckoutTips } from '../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const ConnectedCheckoutRestaurantTipBlock = () => {
  const { t } = useLocalizationContext();

  const { payload, handleRestaurantTip } = useCheckoutContext();
  const { tips, orderSubtotal } = useCheckoutTips({ withNoTipOption: true });

  const selectedTipAmount = payload?.pickupTip ?? 0;

  // ─────────────────────────────────────────────

  return (
    <CheckoutLayoutBlock>
      <TipsGroup
        tips={tips}
        defaultTipValue={tips[0].value}
        orderSubtotalInCents={orderSubtotal}
        sectionTitle={t('checkout.tips.restaurant-tip.title')}
        sectionDescription={t('checkout.tips.restaurant-tip.description')}
        selectedTipAmountInCents={selectedTipAmount}
        setTipAmount={handleRestaurantTip}
        fluidTipButtons
        tipButtonsHorizontalPadding="xsmall"
      />
    </CheckoutLayoutBlock>
  );
};
